<template>
  <div class="pagination">
    <ul class="pagination-list">
      <li v-for="i in pagination" :key="i" class="pagination-item">
        <button 
          class="pagination-btn"
          :class="{ 
            'active-btn-pagination': i === (currentPage + 1),
            'pagination--dots': i === '...'}" 
          :disabled="i === '...'" 
          @click="setPage(i)" 
        >
          {{ i }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>


export default {
  name: "CPagination",
  props: {
    totalPages: {
      default: null,
      required: true
    },
    currentPage: {
      default: 0,
      required: true
    },
  },
  computed: {
    pagination() {
      const delta = 2;
      const left = this.currentPage - delta;
      const right = this.currentPage + delta + 1;
      const range = [];
      const rangeWithDots = [];
      let l;

      for (let i = 1; i <= this.totalPages; i++) {
        if (i === 1 || i === this.totalPages || (i >= left && i < right)) {
          range.push(i);
        }
      }

      for (const i of range) {
        if (l) {
          if (i - l === 2) {
            rangeWithDots.push(l + 1);
          } else if (i - l !== 1) {
            rangeWithDots.push('...');
          }
        }
        rangeWithDots.push(i);
        l = i;
      }

      return rangeWithDots;
    },
  },
  methods: {
    setPage(page) {
      this.$emit('update:currentPage', page); 
    },
  }

};

</script>

<style scoped lang="scss">
.pagination {
  margin: 40px 0;
  margin-left: 10px;

  &-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &-btn {
    width: 42px;
    height: 42px;

    border-radius: 12px;
    border: 1px solid rgba(3, 93, 205, 0.25);
    background: #ffffff;

    color: #035dcd;
    font-weight: 600;
    font-size: 14px;

    cursor: pointer;
    transition: all 0.2s ease;

    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: #eef4ff;
      border-color: #035dcd;
    }

    &:active {
      transform: scale(0.95);
    }
  }

  &--dots {
    width: 42px;
    height: 42px;

    border: none;
    background: transparent;

    color: #8faee3;
    font-size: 18px;
    font-weight: bold;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: default;
  }
}

/* active */
.active-btn-pagination {
  background: linear-gradient(180deg, #035dcd 0%, #0a6eea 100%);
  color: #ffffff;

  border-color: transparent;
  box-shadow: 0 6px 16px rgba(3, 93, 205, 0.35);

  pointer-events: none;
}
</style>
